import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/admin/')({
  component: () => <PageStub title="Admin" description="System administration" />,
});
